import BaseHeadline from '../../../components/general/BaseHeadline'
import BaseIcon from '../../../components/general/BaseIcon'
import BaseText from '../../../components/general/BaseText'

type ValuesType = {
    heading: {
        label?: string
        headline: string
        text?: string
    }
    values: {
        lucideIcon: string
        title: string
        text: string
    }[]
}

export default function Values(props: ValuesType) {
    return (
        <section className="py-20 px-4 w-full sm:px-8 xl:px-0 max-w-page mx-auto">
            <BaseHeadline
                width='w-full'
                headline={props.heading.headline}
                text={props.heading.text}
                label={props.heading.label}
                classProps='pb-24'
            />
            <div className='grid sm:grid-cols-2 gap-6 sm:gap-16'>
                {props.values.map((value, index) => {
                    const mobileColor = index % 2 === 0 ? "text-secondary" : "text-primary"
                    const desktopColor = Math.floor(index / 2) % 2 === index % 2 ? "sm:text-secondary" : "sm:text-primary"
                    return (
                    <div key={index} className='flex flex-col '>
                        <div className='flex gap-2 items-center'>
                            <div className={`${mobileColor} ${desktopColor}`}>
                                <BaseIcon name={value.lucideIcon} size={28} />
                            </div>
                            <BaseHeadline
                                tag='h3'
                                headline={value.title}
                                width='w-fit'
                                headlineClassProps='!text-2xl uppercase tracking-wide font-medium !pb-0'
                            />
                        </div>
                       <BaseText text={value.text} classProps='' />
                    </div>
                    )
                })}

            </div>

        </section>
    )
}
